import { useContext } from "react";
import { FormDataContext } from "../../components/form/form-builder.form";
export const useFormData = () => {
  const formDataContext = useContext(FormDataContext);
  if (formDataContext) {
    return formDataContext;
  }
};
